import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { EmployerService } from '@/infra/services/employer';

interface UpdateEmployerParams {
	id: string;
	name: string;
	company_id: string;
	organization_id: string;
}

const Service = EmployerService.getInstance();

export const useUpdateEmployer = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: UpdateEmployerParams) => Service.update(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_EMPLOYER]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_EMPLOYER]);
			message.success(I18n.get('Employer updated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on update employer'));
		}
	});
};
